import { AxiosInstance } from 'axios';
import { TRCApiResponse } from '@type/common';
import {
  ICity,
  IGetSchoolsVersionsParams,
  ISchoolVersionResponse,
  IGetSchoolVersionsV1Params,
  ISchoolVersionV1,
} from '@type/school.type';

export default (axios: AxiosInstance, school: string) => ({
  /**
   * 取得縣市鄉鎮
   **/
  getCityAndDistricts(): TRCApiResponse<ICity[]> {
    return axios.post(`${school}/api/school/districts`);
  },
  /**
   * 取得學校各年級科目版本
   **/
  getSchoolVersions(
    params: IGetSchoolsVersionsParams,
  ): TRCApiResponse<ISchoolVersionResponse> {
    return axios.post(`${school}/api/v2/school/versions`, params);
  },
  /**
   * 取得學校各年級科目版本 (School Data API v1)
   **/
  getSchoolVersionsV1(
    params: IGetSchoolVersionsV1Params,
  ): TRCApiResponse<ISchoolVersionV1[]> {
    return axios.post(`${school}/api/v1/school/versions`, params);
  },
});
